import React, { FC, useEffect, useState } from 'react';
import Styles from './LineTableV3Refined.module.scss';
import {
  getElementMaximumHeight,
  getLocalStorageWithExpiry,
  replacePlaceholder
} from '../../utils/utils';
import { fetchPrice } from './ProductV3';
import ProductEntitlement from '../ProductDetailsV3/ProductEntitlement';
import ProductPriceV3 from '../ProductDetailsV3/ProductPriceV3';
import {
  AssetPathPropConfig,
  LineTableBasicPropConfig
} from '../../services/LineTableBasicPropConfig';
import {
  DEFAULT_MOBILEPOSTPAID_BUNDLE,
  DEFAULT_WIRELINE_BUNDLE,
  VCTYPE
} from '../../utils/constants';
import { createCartV2 } from '../../services/LineTableService';
import SkeletonLoader from '../SkeletonLoader/SkeletonLoader';
import ProductDetailsV2 from '../ProductDetailsV3/ProductDetailsModal/ProductDetailsV2';
import TVChannelOfferV2 from '../ProductDetailsV3/tv/TVChannelOfferV2';
import { checkCashback, checkGift, formattedContent } from './LineTableV3.utils';
import RichText from '../richtext';
import Cookies from 'js-cookie';
import BenefitsSectionV3 from '../ProductDetailsV3/BenefitsSectionV3';
import GiftConfigV2 from '../ProductDetailsV3/GiftConfigV2';
import ChooseGiftV2 from '../ProductDetailsV3/ChooseGiftV2';
import OrderButton from './OrderButton';
import { trackNewDatalayerEvent } from '../../utils/AnalyticsUtils';
import {
  ADDTOCART,
  COMBINEDEVICE,
  DOWNLOADPRODUCT,
  GAEVENT,
  LINETABLE,
  LINETABLEDEVICE,
  LINETABLEPRODUCT
} from '../../Analytics/AnalyticsConstants';
import { getEcomCartInfo, trackEligibleItem } from '../../models/Analytics/items';
import Dotloader from '../Dotloader/Dotloader';
import { createPortal } from 'react-dom';
import CashbackV2 from '../ProductDetailsV3/CashBackV2/CashbackV2';
import LoginModalV2 from '../login/LoginModalV2';

const BundleProductsV3: FC<any> = ({
  content,
  cards,
  metadata,
  indexKey,
  offeringData,
  uniqueId,
  tabIndex,
  lineCheckCallBack,
  sbStaticConstants,
  address,
  eligibleBundle,
  summaryUrl,
  isMobileFlow,
  updatedContent,
  lineTableContent,
  isProdEnv
}): any => {
  const [bundleProducts, setBundleProducts] = useState<any>({});
  const [mobileProducts, setMobileProducts] = useState<any>({});
  const [entertainOption, setEntertainOption] = useState<any>();
  const [tvChannelName, setTvChannelName] = useState<any>('');
  const [radioValue, setRadioValue] = useState('');
  const [showOptions, setShowOptions] = useState<boolean>(false);
  const [showGift, setShowGift] = useState(false);
  const [cashbackAvailable, setCashbackAvailable] = useState(false);
  const [giftItem, setGiftItem] = useState<any>([]);
  const assetPath = AssetPathPropConfig?.getInstance()?.getAssetPath();
  const [showLoader, setShowLoader] = useState<boolean>(false);
  const [showLogin, setShowLogin] = useState<boolean>(false);
  const id = bundleProducts?.code;
  const productData: any = (offeringData?.[uniqueId] || []).filter(
    (product: any) => product?.id === id
  );
  const showPrice: any = fetchPrice(productData, isMobileFlow);
  const cartEndPoint = LineTableBasicPropConfig?.getInstance()?.getCartUrl();
  const [showProductDetail, setShowProductDetail] = useState(false);
  let isAvailable: boolean | undefined = undefined;
  if (bundleProducts) {
    const productCode: string = bundleProducts?.code;
    isAvailable = address && eligibleBundle?.eligibleBundle?.includes(productCode);
  }

  /*the portal position for the the dotloader*/
  const portalPosition: any =
    typeof window !== undefined && document.getElementById('reusable-linetable');

  useEffect(() => {
    const productResponse = productData?.filter(
      (item: any) => item && item.id === bundleProducts?.code
    );
    setShowGift(checkGift(isMobileFlow ? productResponse : productResponse?.[0]?.bundledOffers));
    setCashbackAvailable(
      checkCashback(isMobileFlow ? productResponse : productResponse?.[0]?.bundledOffers)
    );
  }, [bundleProducts, productData]);

  useEffect(() => {
    if (content?.productStroyObj) {
      const formattedSbContent = formattedContent(content, isMobileFlow, updatedContent);

      if (formattedSbContent?.serviceOptions?.poType === 'TV') {
        setRadioValue(formattedSbContent?.serviceOptions?.radioValue);
        setTvChannelName(formattedSbContent?.serviceOptions?.tvChannelName);
      }
      setBundleProducts(formattedSbContent);
      setMobileProducts(formattedSbContent);
    }
  }, [content]);

  useEffect(() => {
    setTimeout(() => {
      findHeight();
    }, 100);
    window?.addEventListener('load', findHeight);
    window?.addEventListener('resize', findHeight);
    return () => {
      window.removeEventListener('resize', findHeight);
      window.removeEventListener('load', findHeight);
    };
  }, [bundleProducts, showPrice]);

  const showModalPopup = () => {
    if (bundleProducts?.serviceOptions?.avalaible) {
      setShowOptions(true);
    }
  };
  const findHeight = () => {
    getElementMaximumHeight('headingV3' + `${tabIndex}`, cards);
    getElementMaximumHeight('descriptionV3' + `${tabIndex}`, cards);
    getElementMaximumHeight('titleV3' + `${tabIndex}`, cards);
    getElementMaximumHeight('detailsectionv3' + `${tabIndex}`, cards);
    getElementMaximumHeight('product-configv3' + `${tabIndex}`, cards);
    getElementMaximumHeight('gift-section' + `${tabIndex}`, cards);
    getElementMaximumHeight('cashback-section' + `${tabIndex}`, cards);
    getElementMaximumHeight('benefits-section' + `${tabIndex}`, cards);
    getElementMaximumHeight('order-section' + `${tabIndex}`, cards);
    getElementMaximumHeight('price-section' + `${tabIndex}`, cards);
    getElementMaximumHeight('benefits-price-section' + `${tabIndex}`, cards);
    getElementMaximumHeight('contract-section' + `${tabIndex}`, cards);
  };
  let AuthData: any = typeof window !== undefined && Cookies.get('sunriseAuth');
  AuthData = AuthData && JSON.parse(AuthData);

  const createCart = () => {
    setShowProductDetail(false);
    const setLoginCookie =
      lineTableContent?.enableExistingCustomer && AuthData == undefined ? true : false;
    setLoginCookie ? setShowLogin(true) : createCartCall();
  };

  const loginClick = () => {
    setShowLogin(false);
  };

  const onLoginSuccess = () => {
    setShowLogin(false);
    createCartCall();
  };

  const createCartCall = () => {
    setShowProductDetail(false);
    if (bundleProducts?.pageType === 'MOBILE') {
      setShowLoader(true);
      const vcType: { voucher: string; voucherType: string } = getLocalStorageWithExpiry(VCTYPE);
      Object.keys(offeringData)?.length !== 0 &&
        createCartV2(
          productData,
          '',
          showPrice?.promoID ? showPrice?.promoID : DEFAULT_MOBILEPOSTPAID_BUNDLE,
          cartEndPoint,
          'mobile',
          giftItem,
          '',
          '',
          updatedContent?.isQoQaFlow,
          vcType?.voucher
        )
          .then((res: any) => {
            Cookies.remove('one-commerce-cartId', { path: '/' });
            // saving newly created cartid in the cookies.
            Cookies.set('one-commerce-cartId', res?.id, { path: '/' });
            Cookies.set('cartProduct', bundleProducts?.code, { path: '/' });
            trackEligibleItem(ADDTOCART, productData, '', LINETABLEPRODUCT);
            window.location.href = summaryUrl;
          })
          .catch((err) => {
            // eslint-disable-next-line no-console
            console.log(err);
            setShowLoader(false);
          })
          .finally(() => {
            setShowLoader(false);
          });
    } else {
      const linecheckId: any = Cookies.get('one-commerce-linecheckcorrelationid');
      const code = bundleProducts?.code;

      if (!eligibleBundle || !address || !linecheckId) {
        lineCheckCallBack();
      } else {
        setShowLoader(true);
        productData.length !== 0 &&
          createCartV2(
            productData,
            radioValue,
            showPrice?.promoID ? showPrice?.promoID : DEFAULT_WIRELINE_BUNDLE,
            cartEndPoint,
            'fixnet',
            giftItem
          )
            .then((res: any) => {
              Cookies.remove('one-commerce-cartId', { path: '/' });
              // saving newly created cartid in the cookies.
              Cookies.set('one-commerce-cartId', res?.id, { path: '/' });
              Cookies.set('cartProduct', code, { path: '/' });
              Cookies.remove('landline');
              trackEligibleItem(ADDTOCART, productData, '', LINETABLE);
              window.location.href = summaryUrl;
            })
            .catch((err: any) => {
              // eslint-disable-next-line no-console
              console.log(err);
            })
            .finally(() => {
              setShowLoader(false);
            });
      }
    }
  };
  const isSkeletonLoading = Object.keys(bundleProducts)?.length === 0;

  const showDetailsModal = () => {
    setShowProductDetail(!showProductDetail);
    //Analytics Product Details tracking
    let offerData = productData;
    trackNewDatalayerEvent(GAEVENT, DOWNLOADPRODUCT, getEcomCartInfo(offerData, '', LINETABLE));
  };

  const combineWithSmartPhone = () => {
    const promoId = showPrice?.promoID ? showPrice?.promoID : DEFAULT_MOBILEPOSTPAID_BUNDLE;
    let Params = '';
    Params = `?componentCode=&productType=subscription&segmentCode=RC&prefPromo=${
      promoId ?? ''
    }&productCode=${bundleProducts?.code ?? ''}`;
    window.location.href = bundleProducts?.addSmartPhone?.[0]?.buttonLink?.cached_url + Params;
    setMobileSummarySession(bundleProducts, promoId, offeringData);
    trackNewDatalayerEvent(
      GAEVENT,
      COMBINEDEVICE,
      getEcomCartInfo(productData, '', LINETABLEDEVICE)
    );
    trackEligibleItem(ADDTOCART, productData, '', LINETABLEDEVICE);
  };

  const setMobileSummarySession = (product: any, promoId: string, showPrice: any) => {
    const productPrice = showPrice?.[uniqueId]?.filter((prod: any) => prod?.id === product?.code);
    const base: number = productPrice?.[0]?.prices?.[0]?.value ?? 0;
    const discount = productPrice?.[0]?.derivedPrice?.[0]?.value ?? 0;
    const contractDuration = product?.promotionInfo?.[0]?.contractDuration ?? 0;
    const campaignDuration = product?.promotionInfo?.[0]?.campaignDuration ?? 0;
    const sessionObj: any = {
      mobileSubscription: product?.code ?? '',
      mobileSubscriptionPrice: discount > 0 ? discount : base,
      mobileSubscriptionPromo: promoId,
      subGroup: 'MOBILE',
      duration: Number(campaignDuration > 0 ? campaignDuration : contractDuration),
      basePrice: base,
      withoutPromo: false
    };
    typeof window !== undefined &&
      sessionStorage.setItem('one-ecommerce-mobileSummary', JSON.stringify(sessionObj));
  };

  const selectedGiftItem = (item: any) => {
    const itemValue = giftItem.findIndex((gift: any) => item.giftGroupId === gift.giftGroupId);
    const temp = giftItem;
    if (itemValue === -1) temp.push(item);
    else temp[itemValue] = item;
    setGiftItem([...temp]);
  };
  return (
    <>
      {showLoader &&
        portalPosition &&
        createPortal(<Dotloader keyParams='loading' />, portalPosition)}
      {isSkeletonLoading && (
        <div className='w-75 pb-2'>
          <SkeletonLoader />
        </div>
      )}
      {!isSkeletonLoading && eligibleBundle && content && address && !isMobileFlow && (
        <div className={Styles.selected}>
          <span style={{ paddingBottom: '10px' }}>
            {!isAvailable ? (
              <span className={Styles.inactiveicon}>
                <img
                  src={`${assetPath}/icons/cross_disabled.svg`}
                  alt=''
                  width={24}
                  height={24}
                  className={Styles.inactiveicon}
                />
                <span>{sbStaticConstants?.notSubscriptionTxt}</span>
              </span>
            ) : (
              <span className={Styles.activeicon}>
                <img
                  src={`${assetPath}/icons/lineCheck-success.svg`}
                  alt=''
                  width={24}
                  height={24}
                  className={Styles.activeicon}
                />
                <span>{sbStaticConstants?.subscriptionAvalTxt}</span>
              </span>
            )}
          </span>
        </div>
      )}
      <div
        className={`${!isMobileFlow && isAvailable === false ? Styles.overlay : ''}`}
        style={{ flexDirection: 'column' }}
      >
        <div
          className={`${isMobileFlow ? Styles.mobilecard : ''} ${Styles.bundleproductcard} ${
            Styles.productcontainer
          } ${bundleProducts?.highlightText?.length > 0 && Styles.highlightBorder}`}
        >
          {bundleProducts?.highlightText?.length > 0 && (
            <div className={`${Styles.highlightText}`}>{bundleProducts?.highlightText}</div>
          )}

          {bundleProducts?.priceDisplayText?.length > 0 && (
            <div
              className={`${Styles.promocontainer}`}
              style={{
                background: bundleProducts?.bestSellerColor
              }}
            >
              {bundleProducts?.priceDisplayText}{' '}
            </div>
          )}

          <div>
            <div className={`${Styles.detailsection}`} id={`detailsectionv3${tabIndex}${indexKey}`}>
              <div className={`${Styles.headersection}`}>
                <div className={`${Styles.titlesection}`}>
                  <div className={`${Styles.productheader}`} id={`titleV3${tabIndex}${indexKey}`}>
                    {bundleProducts?.displayName}
                  </div>
                  <div>
                    {bundleProducts?.icon && (
                      <img
                        className={`${Styles.imagecontainer}`}
                        src={bundleProducts?.icon}
                        height={15}
                        width={20}
                        alt='bundleProductsIcon'
                      />
                    )}
                  </div>
                </div>
                <div
                  className={`${Styles.productdescription}`}
                  id={`descriptionV3${tabIndex}${indexKey}`}
                >
                  <RichText content={bundleProducts?.description} />
                </div>
                <div className={`${Styles.images}`}>
                  {mobileProducts?.cardImg && (
                    <img
                      className={`${Styles.imagespace} ${
                        bundleProducts?.highlightText?.length > 0 && Styles.borderimage
                      }`}
                      alt='cardimg'
                      src={mobileProducts?.cardImg}
                    />
                  )}
                </div>
              </div>
              <div
                className={`${Styles.productconfig}`}
                id={`product-configv3${tabIndex}${indexKey}`}
              >
                {isSkeletonLoading ? (
                  <>
                    <div className={Styles.space}></div>
                    <SkeletonLoader stylename={Styles.skeletontittle} count={1} />
                    <SkeletonLoader stylename={Styles.skeletonline} count={5} />
                    <div className={Styles.space}></div>
                    <SkeletonLoader stylename={Styles.skeletontittle} count={1} />
                    <SkeletonLoader stylename={Styles.skeletonline} count={5} />
                  </>
                ) : (
                  <div>
                    {bundleProducts?.productConfig &&
                      bundleProducts?.productConfig?.map((product: any, index: number) => {
                        return (
                          <ProductEntitlement
                            content={{ ...product, tvChannelName, entertainOption }}
                            entitlementConfig={bundleProducts?.entitlementConfig}
                            indexKey={index}
                            listlength={cards}
                            showModalPopup={showModalPopup}
                            sbStaticConstants={sbStaticConstants}
                            tabIndex={tabIndex}
                            countryList={bundleProducts?.countryListUrl}
                            metadata={metadata}
                          />
                        );
                      })}
                  </div>
                )}
              </div>
            </div>

            <div
              className={`${Styles.detailsection}`}
              id={`benefits-price-section${tabIndex}${indexKey}`}
            >
              <div
                className={`${Styles.benefitssection}`}
                id={`benefits-section${tabIndex}${indexKey}`}
              >
                {bundleProducts?.benefitsSection?.length > 0 && (
                  <BenefitsSectionV3
                    content={bundleProducts?.benefitsSection}
                    priceCollection={showPrice}
                    sbStaticConstants={sbStaticConstants}
                  />
                )}
              </div>
              <br />
              <div className={`${Styles.giftsection}`} id={`gift-section${tabIndex}${indexKey}`}>
                <div>
                  {bundleProducts?.promoObj?.map((items: any, index: number) => {
                    return (
                      <div key={index}>
                        <div>
                          {items?.isGiftPromo &&
                            showGift &&
                            items?.giftConfig?.map((item: any, index: number) => {
                              return <GiftConfigV2 content={item} key={index} />;
                            })}
                        </div>
                        <div>
                          {items?.isGiftPromo &&
                            showGift &&
                            items?.giftConfigV2?.map((item: any, index: number) => {
                              return (
                                <ChooseGiftV2
                                  content={item}
                                  key={index}
                                  selectedGiftItem={selectedGiftItem}
                                  parentPoType={items?.parentPoType}
                                />
                              );
                            })}
                        </div>
                        <div
                          className={`${Styles.giftsection}`}
                          id={`cashback-section${tabIndex}${indexKey}`}
                        >
                          {items?.cashback &&
                            cashbackAvailable &&
                            items?.cashback?.map((item: any, index: number) => {
                              return <CashbackV2 content={item} key={index} />;
                            })}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>

              <div
                className={`${Styles.ordersection}  `}
                id={`order-section${tabIndex}${indexKey}`}
              >
                {showPrice?.base === '' ? (
                  <div>
                    <SkeletonLoader stylename={Styles.skeletontittle} />
                  </div>
                ) : (
                  <div
                    className={`${Styles.flexgrid}  ${Styles.pricesection} `}
                    id={`price-section${tabIndex}${indexKey}`}
                  >
                    <ProductPriceV3
                      content={bundleProducts}
                      priceCollection={showPrice}
                      toggleSwitch={false}
                      sbStaticConstants={sbStaticConstants}
                    />
                  </div>
                )}{' '}
                <div className={`${updatedContent?.swapButton && Styles.swapButton}`}>
                  <div style={{ padding: '16px 0' }}>
                    <OrderButton
                      content={content}
                      sbStaticConstants={sbStaticConstants}
                      isAvailable={isAvailable}
                      showPrice={showPrice}
                      isSkeletonLoading={isSkeletonLoading}
                      isMobileFlow={isMobileFlow}
                      createCartCall={isMobileFlow ? createCart : createCartCall}
                      address={address}
                      updatedContent={updatedContent}
                    />
                  </div>
                  <div
                    className={Styles.productcontractduration}
                    id={`contract-section${tabIndex}${indexKey}`}
                  >
                    {showPrice?.contractDuration
                      ? replacePlaceholder(sbStaticConstants?.minContractDuration?.substring(1), [
                          showPrice?.contractDuration
                        ])
                      : sbStaticConstants?.simo_no_contract_term}
                  </div>
                  {bundleProducts?.addSmartPhone?.length > 0 && (
                    <div style={{ textAlign: 'center', padding: '4px' }}>
                      {updatedContent?.swapButton && isMobileFlow ? (
                        updatedContent?.ctaLabel && (
                          <div style={{ padding: '16px 0' }}>
                            <button
                              className={`primarybutton`}
                              onClick={() => combineWithSmartPhone()}
                            >
                              <span className={Styles.buttontext}>{updatedContent?.ctaLabel}</span>
                            </button>
                          </div>
                        )
                      ) : (
                        <span className={`${Styles.productdetailslink} ${Styles.addsmartphone}`}>
                          <div>
                            <span>
                              {bundleProducts?.addSmartPhone?.[0]?.buttonIcon?.filename && (
                                <img
                                  src={bundleProducts?.addSmartPhone?.[0]?.buttonIcon?.filename}
                                  width={12}
                                  height={18}
                                  alt='icon'
                                />
                              )}
                            </span>
                            <span>
                              <a onClick={() => combineWithSmartPhone()}>
                                {bundleProducts?.addSmartPhone?.[0]?.buttonLabel}
                              </a>
                            </span>
                          </div>
                        </span>
                      )}
                    </div>
                  )}
                </div>
                <div style={{ textAlign: 'center', padding: '4px' }}>
                  {bundleProducts?.productDetailsModal && (
                    <span className={Styles.productdetailslink} onClick={showDetailsModal}>
                      {sbStaticConstants?.product_details_link}
                    </span>
                  )}
                </div>
                {showProductDetail && (
                  <>
                    <ProductDetailsV2
                      products={bundleProducts?.productDetailsModal}
                      showProductDetail={showProductDetail}
                      setShowProductDetail={setShowProductDetail}
                      content={content}
                      priceCollection={showPrice}
                      addToCart={{
                        ...content,
                        isSkeletonLoading,
                        isAvailable,
                        isMobileFlow,
                        address
                      }}
                      sbStaticConstants={sbStaticConstants}
                      createCartCall={isMobileFlow ? createCart : createCartCall}
                      contractDuration={showPrice?.contractDuration}
                    />
                  </>
                )}
              </div>
            </div>

            {showOptions &&
              (isSkeletonLoading ? (
                <SkeletonLoader />
              ) : (
                <TVChannelOfferV2
                  key={bundleProducts?.code}
                  content={bundleProducts?.serviceOptions}
                  setShowModal={setShowOptions}
                  uniqueId={uniqueId}
                  setEntertainment={setEntertainOption}
                  setTvChannelName={setTvChannelName}
                  code={bundleProducts?.code}
                  showModal={showOptions}
                  radioValue={radioValue}
                  setRadioValue={setRadioValue}
                  metadata={metadata}
                />
              ))}
          </div>
        </div>
      </div>
      {showLogin &&
        lineTableContent?.loginData?.length > 0 &&
        portalPosition &&
        createPortal(
          <LoginModalV2
            content={lineTableContent?.loginData?.[0]}
            closeLogin={loginClick}
            metadata={metadata}
            onSuccess={onLoginSuccess}
            isProdEnv={isProdEnv}
          />,
          portalPosition
        )}
    </>
  );
};
export default BundleProductsV3;
